import React from 'react';
import AdminRouter from '../../components/admin/AdminRouter';

/**
 * Admin Dashboard
 * Protected route - requires authentication
 * Main entry point for admin panel
 */
const AdminDashboard: React.FC = () => {
  return <AdminRouter />;
};

export default AdminDashboard;
